export const baseGuideValidators = {};
